export enum UPLOAD_SOURCE {
  formSubmission = 'form-submission',
  templates = 'templates',
  supportAttachments = 'support-attachments',
  documents = 'documents',
}
